import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileData } from "../../../store/common/settingSlice";

const useVisibilityCheck = () => {

    const { profileData } = useSelector(state => state?.setting);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                if (!profileData?.wallet?.accountId) {
                    dispatch(fetchProfileData());
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);


    return
}

export default useVisibilityCheck